import { useQuery } from "@tanstack/react-query";
import { api, readJson } from "../../lib/api";
import { Avatar } from "../Avatar";
import { STATUS_LABEL } from "../CrewPanels";

// Where today's time went: trimming vs each non-trimming status, per person.
type Row = {
  player_id: number; name: string; avatar_at: number | null;
  current: { status: string; started_at: number } | null;
  trimming_minutes: number; status_minutes: Record<string, number>;
};

const hm = (m: number) => (m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m}m`);

export function TimeTodayPanel() {
  const midnight = new Date(); midnight.setHours(0, 0, 0, 0);
  const { data } = useQuery({
    queryKey: ["status-today", midnight.getTime()],
    queryFn: () => api.get(`/api/status/today?from=${midnight.getTime()}`).then((r) => readJson<{ crew: Row[] }>(r)),
    refetchInterval: 30_000,
  });
  if (!data?.crew.length) return null;
  const keys = Object.keys(STATUS_LABEL);

  return (
    <div className="panel" data-testid="time-today">
      <h2>Time today</h2>
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr><th>Trimmer</th><th>Now</th><th>Trimming</th>{keys.map((k) => <th key={k}>{STATUS_LABEL[k]}</th>)}<th>Not trimming</th></tr>
          </thead>
          <tbody>
            {data.crew.map((p) => {
              const off = keys.reduce((t, k) => t + (p.status_minutes[k] ?? 0), 0);
              const total = off + p.trimming_minutes;
              return (
                <tr key={p.player_id} data-testid={`time-row-${p.player_id}`}>
                  <td><span className="row" style={{ gap: 8, alignItems: "center" }}><Avatar playerId={p.player_id} name={p.name} avatarAt={p.avatar_at} size={28} />{p.name}</span></td>
                  <td>{p.current ? <span className="pill live-pill">{STATUS_LABEL[p.current.status] ?? p.current.status}</span> : "–"}</td>
                  <td>{hm(p.trimming_minutes)}</td>
                  {keys.map((k) => <td key={k}>{p.status_minutes[k] ? hm(p.status_minutes[k]) : "–"}</td>)}
                  <td><b>{total ? `${Math.round((off / total) * 100)}%` : "–"}</b></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
